import { useState, useEffect } from "react";
import { Modal, Button, Form, Badge, InputGroup } from "react-bootstrap";
import { CrossIcon } from "../../components/Icons";

const EmailModal = ({
    show,
    onCancel,
    onSubmit,
    emailList = [],
    category = "RFQ",
    buttonText = "Send"
}) => {
    const [manualEmail, setManualEmail] = useState("");
    const [error, setError] = useState("");
    const [selectedEmails, setSelectedEmails] = useState([]);

    const filteredEmails = emailList
        .filter((e) => e.label === category)
        .map((e) => e.email);

    useEffect(() => {
        setSelectedEmails([]);
        setManualEmail("");
        setError("");
    }, [show, category]);

    const validateEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleAddEmail = (email) => {
        if (!validateEmail(email)) {
            setError("Invalid email format.");
            return;
        }
        if (selectedEmails.includes(email)) {
            setError("Email already added.");
            return;
        }
        setSelectedEmails([...selectedEmails, email]);
        setManualEmail("");
        setError("");
    };

    const handleDropdownChange = (e) => {
        const email = e.target.value;
        if (email && !selectedEmails.includes(email)) {
            setSelectedEmails([...selectedEmails, email]);
        }
    };

    const handleRemoveEmail = (emailToRemove) => {
        setSelectedEmails(selectedEmails.filter((e) => e !== emailToRemove));
    };

    const handleSend = () => {
        if (selectedEmails.length === 0) {
            setError("Please select or enter at least one email.");
            return;
        }
        onSubmit(selectedEmails);
    };

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title className="fw-semibold">
                    {buttonText} Email ({category})
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group className="mb-4">
                    <Form.Label className="fw-medium">Select an Email</Form.Label>
                    <Form.Select
                        onChange={handleDropdownChange}
                        defaultValue=""
                        className="shadow-sm"
                    >
                        <option value="" disabled>
                            -- Choose from existing emails --
                        </option>
                        {filteredEmails.map((email, idx) => (
                            <option key={idx} value={email}>
                                {email}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label className="fw-medium">Or Enter an Email</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="email"
                            placeholder="example@domain.com"
                            value={manualEmail}
                            onChange={(e) => setManualEmail(e.target.value)}
                            className="shadow-sm"
                        />
                        <Button className="!bg-complementaryPrimaryColor border-0" onClick={() => handleAddEmail(manualEmail)}>
                            Add
                        </Button>
                    </InputGroup>
                </Form.Group>

                {error && <div className="text-danger mb-3 fw-semibold">{error}</div>}

                {selectedEmails.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-4">
                        {selectedEmails.map((email, index) => (
                            <div
                                key={index}
                                className="flex items-center bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm"
                            >
                                <span className="mr-2">{email}</span>
                                <button
                                    onClick={() => handleRemoveEmail(email)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <CrossIcon />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    className="bg-complementaryPrimaryColor border-0"
                    onClick={handleSend}
                >
                    {buttonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmailModal;
